export const START_LOADING = 'app/services/Views/START_LOADING';
export const STOP_LOADING = 'app/services/Views/STOP_LOADING';

export const CLEAR_NOTIFICATIONS = 'app/services/Views/CLEAR_NOTIFICATIONS';

export const GET_USER_VIEWS_SUCCESS = 'app/services/Views/GET_USER_VIEWS_SUCCESS';
export const GET_USER_VIEWS_FAIL = 'app/services/Views/GET_USER_VIEWS_FAIL';

export const CREATE_VIEW_SUCCESS = 'app/services/Views/CREATE_VIEW_SUCCESS';
export const CREATE_VIEW_FAIL = 'app/services/Views/CREATE_VIEW_FAIL';

export const UPDATE_VIEW_SUCCESS = 'app/services/Views/UPDATE_VIEW_SUCCESS';
export const UPDATE_VIEW_FAIL = 'app/services/Views/UPDATE_VIEW_FAIL';

export const DELETE_VIEW_SUCCESS = 'app/services/Views/DELETE_VIEW_SUCCESS';
export const DELETE_VIEW_FAIL = 'app/services/Views/DELETE_VIEW_FAIL';

export const GET_RECURRING_EMAILS_SUCCESS = 'app/services/Views/GET_RECURRING_EMAILS_SUCCESS';
export const GET_RECURRING_EMAILS_FAIL = 'app/services/Views/GET_RECURRING_EMAILS_FAIL';

export const CREATE_RECURRING_EMAIL_SUCCESS = 'app/services/Views/CREATE_RECURRING_EMAIL_SUCCESS';
export const CREATE_RECURRING_EMAIL_FAIL = 'app/services/Views/CREATE_RECURRING_EMAIL_FAIL';

export const UPDATE_RECURRING_EMAIL_SUCCESS = 'app/services/Views/UPDATE_RECURRING_EMAIL_SUCCESS';
export const UPDATE_RECURRING_EMAIL_FAIL = 'app/services/Views/UPDATE_RECURRING_EMAIL_FAIL';

export const DELETE_RECURRING_EMAIL_SUCCESS = 'app/services/Views/DELETE_RECURRING_EMAIL_SUCCESS';
export const DELETE_RECURRING_EMAIL_FAIL = 'app/services/Views/DELETE_RECURRING_EMAIL_FAIL';

export const startLoading = () => ({
  type: START_LOADING,
});

export const stopLoading = () => ({
  type: STOP_LOADING,
});

export const receivedUserViewsSuccess = (views) => ({
  type: GET_USER_VIEWS_SUCCESS,
  payload: { views },
});

export const receivedUserViewsFail = (errors) => ({
  type: GET_USER_VIEWS_FAIL,
  payload: { errors },
});

export const receivedCreateViewSuccess = (view) => ({
  type: CREATE_VIEW_SUCCESS,
  payload: { view },
});

export const receivedCreateViewFail = (errors) => ({
  type: CREATE_VIEW_FAIL,
  payload: { errors },
});

export const receivedUpdateViewSuccess = (view, resetDefault) => ({
  type: UPDATE_VIEW_SUCCESS,
  payload: {
    view,
    resetDefault,
  },
});

export const receivedUpdateViewFail = (errors) => ({
  type: UPDATE_VIEW_FAIL,
  payload: { errors },
});

export const receivedDeleteViewSuccess = (id) => ({
  type: DELETE_VIEW_SUCCESS,
  payload: { id },
});

export const receivedDeleteViewFail = (errors) => ({
  type: DELETE_VIEW_FAIL,
  payload: { errors },
});

export const receivedGetRecurringEmailsSuccess = (recurringEmails) => ({
  type: GET_RECURRING_EMAILS_SUCCESS,
  payload: { recurringEmails },
});

export const receivedGetRecurringEmailsFail = (errors) => ({
  type: GET_RECURRING_EMAILS_FAIL,
  payload: { errors },
});

export const receivedCreateRecurringEmailSuccess = (recurringEmail) => ({
  type: CREATE_RECURRING_EMAIL_SUCCESS,
  payload: { recurringEmail },
});

export const receivedCreateRecurringEmailFail = (errors) => ({
  type: CREATE_RECURRING_EMAIL_FAIL,
  payload: { errors },
});

export const receivedUpdateRecurringEmailSuccess = (recurringEmail) => ({
  type: UPDATE_RECURRING_EMAIL_SUCCESS,
  payload: { recurringEmail },
});

export const receivedUpdateRecurringEmailFail = (errors) => ({
  type: UPDATE_RECURRING_EMAIL_FAIL,
  payload: { errors },
});

export const receivedDeleteRecurringEmailSuccess = (id) => ({
  type: DELETE_RECURRING_EMAIL_SUCCESS,
  payload: { id },
});

export const receivedDeleteRecurringEmailFail = (errors) => ({
  type: DELETE_RECURRING_EMAIL_FAIL,
  payload: { errors },
});

export const receivedClearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
});
